import clsx from 'clsx';
import React from 'react';

import CSVDownloadLink from '@components/Project/CSVDownloadLink';
import { Project } from '@interfaces/projects';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

interface BottomSectionProps extends Pick<Project, 'id' | 'notes' | 'slug'> {
  isCurrentUserCorpOrGroupSubscriber: boolean;
}

const BottomSection = ({
  id: projectId,
  isCurrentUserCorpOrGroupSubscriber,
  notes: projectNotes,
  slug: projectSlug,
}: BottomSectionProps) => {
  return (
    <div className="grid grid-cols-2">
      {isCurrentUserCorpOrGroupSubscriber && <CSVDownloadLink id={projectId} slug={projectSlug} />}
      {projectNotes && (
        <p
          className={clsx(
            'whitespace-break-spaces font-suisse-screen text-caption-md text-grayscale-gray',
            {
              'justify-self-end': isCurrentUserCorpOrGroupSubscriber,
            }
          )}
        >
          {AuthoredContentReactToHtmlParser(projectNotes)}
        </p>
      )}
    </div>
  );
};

export default BottomSection;
